import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { sentrySetUser } from '@thiememeulenhoff/ng-sdk';
import { PlatformService } from '@thiememeulenhoff/ng-api-gateway';
import { UserInterface } from '@thiememeulenhoff/types';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly #platformService = inject(PlatformService);

  readonly #userSubject = new BehaviorSubject<UserInterface | undefined>(
    undefined,
  );

  readonly user$ = this.#userSubject.asObservable();

  get user() {
    return this.#userSubject.value;
  }

  setUser = (user: UserInterface | undefined) => {
    sentrySetUser(user?.identifier);
    this.#userSubject.next(user);
  };

  fetchUser(renew = false) {
    return this.#platformService
      .me(renew)
      .pipe(tap((user) => this.setUser(user)));
  }
}
